import { POSTER_VARIANTS } from "../PosterChapter.constants";
import ServiceHubPosterChapterData from '../PosterChapter.interface';
import LayoutVariant1 from "./LayoutVariant1";
import LayoutVariant2 from "./LayoutVariant2";
import LayoutVariant3 from "./LayoutVariant3";
import LayoutVariant4 from "./LayoutVariant4";
import LayoutVariant5 from "./LayoutVariant5";
import LayoutVariant6 from "./LayoutVariant6";

function PosterLayout(props: ServiceHubPosterChapterData) {
    const { variant } = props;

    switch (variant) {
        case POSTER_VARIANTS.VARIANT_6:
            return <LayoutVariant6 {...props} />
        case POSTER_VARIANTS.VARIANT_5:
            return <LayoutVariant5 {...props} />
        case POSTER_VARIANTS.VARIANT_4:
            return <LayoutVariant4 {...props} />
        case POSTER_VARIANTS.VARIANT_3:
            return <LayoutVariant3 {...props} />
        case POSTER_VARIANTS.VARIANT_2:
            return <LayoutVariant2 {...props} />
        default:
            return <LayoutVariant1 {...props} />
    }
}

export default PosterLayout;
